import React from "react";
import { useReveal, useMeta } from "./shared.jsx";
import { HomeHero } from "./sections/HomeHero.jsx";
import { HomeClients } from "./sections/HomeClients.jsx";
import { HomeKpiStrip } from "./sections/HomeKpiStrip.jsx";
import { HomeServices } from "./sections/HomeServices.jsx";
import { HomeCases } from "./sections/HomeCases.jsx";
import { HomeReason } from "./sections/HomeReason.jsx";
import { HomeTestimonials } from "./sections/HomeTestimonials.jsx";
import { HomeFinalCta } from "./sections/HomeFinalCta.jsx";
import home from "../content/home.json";

// Homepage — cała treść pochodzi z ../content/home.json (edytowalne przez Puck na /admin).
// Każda sekcja to wspólny komponent z ./sections/, używany też przez podgląd Puck (1:1).
const HomePage = ({ navigate }) => {
  const ref = React.useRef(null);
  useReveal(ref);
  useMeta({
    title: "Agencja performance marketingu dla e-commerce — Google Ads, Meta, Allegro | Let's commerce",
    description: "Polska agencja performance marketingu dla e-commerce. Google Ads, Meta Ads, Allegro Ads, Conversions API, analityka GA4. Bez umowy, miesiąc do miesiąca. Senior specialist od pierwszego dnia."
  });

  return (
    <div ref={ref}>
      <HomeHero {...home.hero} onPrimary={() => navigate("/kontakt")} onSecondary={() => navigate("/o-nas")} />
      <HomeClients clients={home.clients} />
      <HomeKpiStrip kpis={home.kpis} />
      <HomeServices {...home.services} navigate={navigate} />
      <HomeCases {...home.cases} navigate={navigate} />
      <HomeReason {...home.reason} navigate={navigate} />
      <HomeTestimonials {...home.testimonials} />
      <HomeFinalCta chips={home.finalCtaChips} navigate={navigate} />
    </div>
  );
};

export { HomePage };
